import { render, staticRenderFns } from "./notes-list.vue?vue&type=template&id=0a03f86b&scoped=true&"
import script from "./notes-list.vue?vue&type=script&lang=js&"
export * from "./notes-list.vue?vue&type=script&lang=js&"
import style0 from "./notes-list.vue?vue&type=style&index=0&id=0a03f86b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a03f86b",
  null
  
)

export default component.exports